// lib
import React, { useState } from "react";
import PropTypes from "prop-types";
import { filter, reject, whereEq } from "ramda";
import { useTranslation } from "react-i18next";
import { Grid, IconButton, List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core";
import { Add, MoreVert } from "@material-ui/icons";
import CourseListContents from "components/plannings/micro/CourseListContents";

// src
import Tooltip from "components/partials/Tooltip";
import { ACADEMIC_YEARS, CAMPUSES, CAMPUSES_DISPLAY, SEMESTERS, getCurrentYear } from "./filters";
import Select from "../partials/Select";

const getDisplayeds = (items, campus, semester, academicYear) => {
  if (!items) return [];
  const predicate = reject((x) => !x, { campus, semester, academicYear });
  return filter(whereEq(predicate), items);
};

const Courses = ({ createHandleSelect, items, selfTranslate }) => {
  const currentYear = getCurrentYear();
  const [campus, setCampus] = useState();
  const [semester, setSemester] = useState();
  const [academicYear, setAcademicYear] = useState(currentYear);
  const { t } = useTranslation();
  const displayeds = getDisplayeds(items, campus, semester, academicYear);
  return (
    <>
      <Grid container spacing={3}>
        <Grid item>
          <Select
            defaultLabel={t("common.campus")}
            values={CAMPUSES}
            labels={CAMPUSES_DISPLAY}
            selectCallback={setCampus}
          />
        </Grid>
        <Grid item>
          <Select
            defaultLabel={t("common.semester")}
            values={SEMESTERS}
            selectCallback={setSemester}
          />
        </Grid>
        <Grid item>
          <Select
            defaultLabel={t("common.academicYear")}
            values={ACADEMIC_YEARS}
            selectCallback={setAcademicYear}
            initial={currentYear}
          />
        </Grid>
      </Grid>

      <List dense>
        {displayeds.map((i) => (
          <ListItem key={i.id}>
            <ListItemIcon onClick={createHandleSelect(i)}>
              <IconButton size="small" className={i.campus ? `add--${i.campus}` : "add"}>
                <Add />
              </IconButton>
            </ListItemIcon>
            <ListItemIcon>
              <Tooltip
                main={
                  <IconButton size="small" aria-label="delete">
                    <MoreVert className="light-icon" />
                  </IconButton>
                }
                render={() => <CourseListContents course={i} />}
              />
            </ListItemIcon>
            <ListItemText primary={selfTranslate(i.display)} secondary={i.breadcrumb} />
          </ListItem>
        ))}
      </List>
    </>
  );
};

Courses.propTypes = {
  // from parent
  createHandleSelect: PropTypes.func.isRequired,
  selfTranslate: PropTypes.func.isRequired,
  items: PropTypes.array,
};

Courses.defaultProps = {
  items: [],
};

export default Courses;
